<messages>["./Contact"]</messages>

<!--
================================================================================
  Template (HTML)
================================================================================
-->

<template>
  <div>
    <base-layout mw3>
      <v-col cols="12">
        <v-alert
          v-model="isSuccessAlertVisible"
          type="success"
          dismissible>
          <i18n path="update.success">
            <template #link>
              <router-link
                :to="{name: 'contact.view', params: { registry, handle }}"
                v-text="handle"/>
            </template>
          </i18n>
        </v-alert>
      </v-col>
    </base-layout>

    <v-alert
      id="invalidDataAlert"
      v-t="'general.invalid.form'"
      type="error"
      :value="isInvalidDataAlertVisible"/>

    <contact-create-update
      :contact-data="{contact: {
        handle,
        registryType: registry
      }}"
      @unsavedChanges="setUnsavedChanges"
      @success="onSuccess"
      @dataValidityChanged="onDataValidityChanged"
      @cancel="back"/>
  </div>
</template>

<!--
================================================================================
  Logic (JavaScript)
================================================================================
-->

<script>
  import goTo from 'vuetify/lib/services/goto'

  import unsavedChangesHelper from '@/app/core/mixins/UnsavedChangesHelper'
  import BaseLayout from '@/app/core/components/BaseLayout'

  import ContactCreateUpdate from './ContactCreateUpdate'
  import {mapMutations} from 'vuex'

  export default {
    name: 'ContactEdit',

    components: {
      BaseLayout,
      ContactCreateUpdate
    },

    mixins: [unsavedChangesHelper],

    props: {
      handle: {type: String, required: true},
      registry: {type: String, required: true}
    },

    data () {
      return {
        isSuccessAlertVisible: false,
        isInvalidDataAlertVisible: false
      }
    },

    methods: {
      ...mapMutations ('notification', ['addEvent']),

      onSuccess ({handle, registry}) {
        this.addEvent ({
          type: 'success',
          message: this.$t ('update.success', {link: handle}),
          objects: [{name: handle, link: {name: 'contact.view', params: {registry, handle}}}]
        })
        this.isSuccessAlertVisible = true
      },

      onDataValidityChanged (isValid) {
        console.warn ('onDataValidityChanged', isValid)
        this.isInvalidDataAlertVisible = !isValid
        if (this.isInvalidDataAlertVisible) this.scrollToAlert ()
      },

      back () {
        this.$router.back ()
      },

      scrollToAlert () {
        goTo ('#invalidDataAlert')
      }
    }
  }
</script>
